import { motion, useReducedMotion } from 'motion/react';
import { useDemoRequestScreen } from '../hooks/useDemoRequestScreen';
import DemoRequestAside from './DemoRequestAside';
import DemoRequestHeader from './DemoRequestHeader';
import DemoRequestStepForm from './DemoRequestStepForm';
import DemoRequestSubmitted from './DemoRequestSubmitted';
import './demoRequest.css';

const transition = { duration: 0.7, ease: [0.16, 1, 0.3, 1] };

/** Il questionario per richiedere una demo, con la conferma dopo l'invio. */
export default function DemoRequestForm() {
  const screen = useDemoRequestScreen();
  const reduceMotion = useReducedMotion();
  const enter = (delay = 0) =>
    reduceMotion
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          animate: { opacity: 1, y: 0 },
          transition: { ...transition, delay },
        };

  return (
    <div className="demo-request min-h-screen">
      <div className="relative z-10 px-4 pb-16 pt-10 lg:px-6">
        <div className="mx-auto w-[min(1240px,100%)]">
          <motion.div {...enter()}>
            <DemoRequestHeader />
          </motion.div>
          <main>
            {screen.submitted ? (
              <motion.div {...enter()}>
                <DemoRequestSubmitted summary={screen.summary} />
              </motion.div>
            ) : (
              <div className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr]">
                <motion.div {...enter()} className="lg:sticky lg:top-8 lg:self-start">
                  <DemoRequestAside
                    steps={screen.steps}
                    step={screen.step}
                    snapshot={screen.snapshot}
                  />
                </motion.div>
                <motion.div {...enter(0.05)}>
                  <DemoRequestStepForm screen={screen} />
                </motion.div>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
